import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { get, capitalize, isEmpty } from 'lodash';
import { FormattedMessage } from 'react-intl';

const SideWhatsYourWhy = ({ classes, user, obfuscateView }) => {
  if (!isEmpty(get(user, 'why_values'))) {
    const whyValues = get(user, 'why_values', []).map(p => capitalize(p.replaceAll('_', ' ')));
    return (
      <div className={classes.status}>
        <strong><FormattedMessage id="profile_page.whats_your_why"/></strong>
        {!obfuscateView && (
          <p>
            {whyValues.map(s => (
              <span>
                {s}
                <br />
              </span>
            ))}
          </p>
        )}
        {obfuscateView && <p className="blurry-text">???</p>}
      </div>
    );
  }
  return <div />;
};

const styles = {
  status : {
    marginBottom : 15,
    width        : 170,
  },
};

export default withStyles(styles)(SideWhatsYourWhy);
